<div>
  @if (isInfrastructureDelegate()) {
    <div class="overflow-menu" (clickOutside)="overflowMenuActive = false">
      <button
        class="overflow-menu__button button button--small button--secondary"
        [class.active]="overflowMenuActive"
        [class.button--disabled]="!selfServiceEnabled()"
        (click)="overflowMenuActive = !overflowMenuActive"
      >
        <svg-icon src="assets/images/icons/cog.svg" class="button__icon"></svg-icon>
        <span> {{ "Global.Modify" | translate }}</span>
      </button>
      <div class="overflow-menu__items">
        <div
          class="overflow-menu__item"
          (click)="selectItem('vlan-l2vpn')"
          [matTooltip]="'Selfservice.Tooltip.Vlan' | translate"
          [matTooltipPosition]="'above'"
        >
          {{ "OverflowMenu.ModifyVlan" | translate }}
        </div>
        <div
          class="overflow-menu__item"
          (click)="selectItem('add-port')"
          [matTooltip]="'Selfservice.Tooltip.AddPort' | translate"
          [matTooltipPosition]="'above'"
        >
          {{ "OverflowMenu.AddPort" | translate }}
        </div>
        <div
          class="overflow-menu__item"
          (click)="selectItem('remove-port')"
          [matTooltip]="'Selfservice.Tooltip.RemovePort' | translate"
          [matTooltipPosition]="'above'"
        >
          {{ "OverflowMenu.RemovePort" | translate }}
        </div>
      </div>
    </div>
  }
</div>
